export const LANDING_ROUTES = {
    home: "/",
    programs: "/programmata",
};

const LANDING_PATHS = Object.values(LANDING_ROUTES);

export function isLandingRoute(pathname) {
    if (typeof pathname !== "string") {
        return false;
    }
    const normalized = pathname.replace(/\/+$/, "").toLowerCase() || "/";
    return LANDING_PATHS.includes(normalized);
}
